'use strict';

exports.searchMethods = [
    'SimpleSearch',
    'ExactStructureSearch',
    'SubstructureSearch',
    'SimilaritySearch',
    'IntrinsicPropertiesSearch',
    'DataSourceSearch',
    'ElementsSearch',
    'PredictedPropertiesSearch',
    'AdvancedSearch'
];

exports.resultMethods = [
    'GetSearchResult',
    'GetSearchResultWithRelevance',
    'GetSearchResultAsCompounds',
    'GetSearchResultAsSdf'
];
exports.chemspiderUrl = 'https://www.cheminfo.org/chemspider/JSON.ashx';




// WEBPACK FOOTER //
// ./src/constants.js